import type { RouteRecordRaw } from 'vue-router';

export const ROUTE_NAMES = {
  ACTIVITY: 'activity',
  ADD_ACTIVITY: 'addActivity',
  ADD_MEASUREMENT: 'addMeasurement',
  ADD_OWN_RECIPE: 'addOwnRecipe',
  DEBUG: 'debug',
  DIARY: 'diary',
  EDIT_MEASUREMENT: 'editMeasurement',
  EDIT_OWN_RECIPE: 'editOwnRecipe',
  FAVORITES: 'favorites',
  INDEX: 'index',
  LEGAL_PAGES_INDEX: 'legalIndex',
  LEGAL_DOC: 'legalDoc',
  LOGIN: 'login',
  MAIN_LAYOUT: 'mainLayout',
  NUTRITION: 'nutrition',
  NUTRITION_RATION: 'diet',
  NUTRITION_RECIPE: 'recipe',
  ONBOARDING: 'onboarding',
  PAY_PLAN: 'payPlan',
  PROMOCODE: 'promocode',
  SELECT_MEASUREMENT: 'selectMeasurement',
  SELECT_RECIPE: 'selectRecipe',
  SELECT_PLAN: 'selectPlan',
  TRAINING: 'training',
  TRAINING_PROMO: 'trainingPromo',
  TRAINING_WORKOUT_PLAN: 'trainingExercise',
  USER_FORM: 'userForm',
  USER_PROFILE: 'userProfile',
  USER_STATISTICS: 'userStatistics',
  USER_SUBSCRIPTION: 'userSubscription',
} as const


const routes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('layouts/MainLayout.vue'),
    name: ROUTE_NAMES.MAIN_LAYOUT,
    children: [
      {
        path: 'first-use',
        name: ROUTE_NAMES.ONBOARDING,
        meta: { auth: true, paid: false },
        component: () => import('pages/Onboarding/OnboardingPage.vue')
      },
      {
        path: 'select-plan',
        name: ROUTE_NAMES.SELECT_PLAN,
        meta: { auth: true, paid: false },
        component: () => import('pages/Onboarding/SelectPlan.vue')
      },
      {
        path: 'select-plan/:id',
        name: ROUTE_NAMES.PAY_PLAN,
        meta: { auth: true, paid: false },
        component: () => import('pages/Onboarding/PayPlan.vue')
      },
      {
        path: 'select-plan/:id/promo-code',
        name: ROUTE_NAMES.PROMOCODE,
        meta: { auth: true, paid: false },
        component: () => import('pages/Onboarding/PromoCodePage.vue')
      },
      {
        path: '',
        name: ROUTE_NAMES.INDEX,
        meta: { auth: true, paid: true },
        component: () => import('pages/Index/IndexPage.vue')
      },
      {
        path: 'diary',
        name: ROUTE_NAMES.DIARY,
        meta: { auth: true, paid: true },
        component: () => import('pages/Diary/DiaryPage.vue')
      },
      {
        path: 'diary/activities',
        name: ROUTE_NAMES.ADD_ACTIVITY,
        meta: { auth: true, paid: true },
        component: () => import('pages/Diary/AddActivity.vue')
      },
      {
        path: 'diary/activities/:id',
        name: ROUTE_NAMES.ACTIVITY,
        meta: { auth: true, paid: true },
        component: () => import('pages/Diary/ActivityPage.vue')
      },
      {
        path: 'diary/measurements',
        name: ROUTE_NAMES.SELECT_MEASUREMENT,
        meta: { auth: true, paid: true },
        component: () => import('pages/Diary/AddMeasurement.vue')
      },
      {
        path: 'diary/measurements/:id',
        name: ROUTE_NAMES.ADD_MEASUREMENT,
        meta: { auth: true, paid: true },
        component: () => import('pages/Diary/MeasurementPage.vue')
      },
      {
        path: 'diary/measurements/edit/:id',
        name: ROUTE_NAMES.EDIT_MEASUREMENT,
        meta: { auth: true, paid: true },
        component: () => import('pages/Diary/EditMeasurementPage.vue')
      },
      {
        path: 'diary/select-recipe',
        name: ROUTE_NAMES.SELECT_RECIPE,
        meta: { auth: true, paid: true },
        component: () => import('pages/Diary/SelectRecipe.vue')
      },
      {
        path: 'favorites',
        name: ROUTE_NAMES.FAVORITES,
        meta: { auth: true, paid: true },
        component: () => import('pages/Favorites/FavoritesPage.vue'),
      },
      {
        path: 'nutrition',
        name: ROUTE_NAMES.NUTRITION,
        meta: { auth: true, paid: true },
        component: () => import('pages/Nutrition/NutritionPage.vue'),
      },
      {
        path: 'nutrition/ration/:slug',
        name: ROUTE_NAMES.NUTRITION_RATION,
        meta: { auth: true, paid: true },
        component: () => import('pages/Nutrition/RationPage.vue')
      },
      {
        path: 'nutrition/recipe/:slug',
        name: ROUTE_NAMES.NUTRITION_RECIPE,
        meta: { auth: true, paid: true },
        component: () => import('pages/Nutrition/RecipePage.vue')
      },
      {
        path: 'nutrition/add-recipe',
        name: ROUTE_NAMES.ADD_OWN_RECIPE,
        meta: { auth: true, paid: true },
        component: () => import('pages/Nutrition/AddOwnRecipePage.vue'),
      },
      {
        path: 'nutrition/my-recipe/:slug',
        name: ROUTE_NAMES.EDIT_OWN_RECIPE,
        meta: { auth: true, paid: true },
        component: () => import('pages/Nutrition/EditOwnRecipePage.vue'),
      },
      {
        path: 'profile',
        name: ROUTE_NAMES.USER_PROFILE,
        meta: { auth: true, paid: false },
        component: () => import('pages/UserProfile/UserProfilePage.vue')
      },
      {
        path: 'profile/form',
        name: ROUTE_NAMES.USER_FORM,
        meta: { auth: true, paid: false },
        component: () => import('pages/UserProfile/UserFormPage.vue')
      },
      {
        path: 'profile/statistics',
        name: ROUTE_NAMES.USER_STATISTICS,
        meta: { auth: true, paid: false },
        component: () => import('pages/UserProfile/UserStatisticsPage.vue')
      },
      {
        path: 'profile/subscription',
        name: ROUTE_NAMES.USER_SUBSCRIPTION,
        meta: { auth: true, paid: false },
        component: () => import('pages/UserProfile/UserSubscription.vue')
      },
      {
        path: 'training',
        name: ROUTE_NAMES.TRAINING,
        meta: { auth: true, paid: true },
        component: () => import('pages/Training/TrainingPage.vue')
      },
      {
        path: 'training/:slug',
        name: ROUTE_NAMES.TRAINING_WORKOUT_PLAN,
        meta: { auth: true, paid: true },
        component: () => import('pages/Training/WorkoutPlanPage.vue')
      },
      {
        path: 'training/first-use',
        name: ROUTE_NAMES.TRAINING_PROMO,
        meta: { auth: true, paid: true },
        component: () => import('pages/Training/TrainingPromoPage.vue')
      },
      {
        path: 'conditions',
        name: ROUTE_NAMES.LEGAL_PAGES_INDEX,
        meta: { auth: null, paid: false },
        component: () => import('pages/Legal/LegalIndexPage.vue')
      },
      {
        path: 'conditions/:slug',
        name: ROUTE_NAMES.LEGAL_DOC,
        meta: { auth: null, paid: false },
        component: () => import('pages/Legal/LegalDocPage.vue')
      },
      {
        path: 'debug',
        name: ROUTE_NAMES.DEBUG,
        meta: { auth: null, paid: false },
        component: () => import('pages/DebugPage.vue')
      },
    ],
  },
  {
    path: '/start/',
    component: () => import('layouts/AuthLayout.vue'),
    children: [
      {
        path: '',
        name: ROUTE_NAMES.LOGIN,
        meta: { auth: false, paid: false },
        component: () => import('pages/Login/LoginPage.vue')
      },
    ],
  },
  {
    path: '/:catchAll(.*)*',
    component: () => import('pages/ErrorNotFound.vue'),
  },
];

export default routes;
